/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCompanyDto } from './GetCompanyDto';
import {
    GetCompanyDtoFromJSON,
    GetCompanyDtoFromJSONTyped,
    GetCompanyDtoToJSON,
} from './GetCompanyDto';
import type { GetEmployeeDto } from './GetEmployeeDto';
import {
    GetEmployeeDtoFromJSON,
    GetEmployeeDtoFromJSONTyped,
    GetEmployeeDtoToJSON,
} from './GetEmployeeDto';
import type { GetTeamDto } from './GetTeamDto';
import {
    GetTeamDtoFromJSON,
    GetTeamDtoFromJSONTyped,
    GetTeamDtoToJSON,
} from './GetTeamDto';

/**
 * 
 * @export
 * @interface GetAuthorizedDto
 */
export interface GetAuthorizedDto {
    /**
     * 
     * @type {string}
     * @memberof GetAuthorizedDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetAuthorizedDto
     */
    systemNumber: number;
    /**
     * 
     * @type {Date}
     * @memberof GetAuthorizedDto
     */
    endDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GetAuthorizedDto
     */
    maxAmount: string;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetAuthorizedDto
     */
    employee: GetEmployeeDto;
    /**
     * 
     * @type {GetCompanyDto}
     * @memberof GetAuthorizedDto
     */
    company: GetCompanyDto;
    /**
     * 
     * @type {GetTeamDto}
     * @memberof GetAuthorizedDto
     */
    team?: GetTeamDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetAuthorizedDto
     */
    active: boolean;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetAuthorizedDto
     */
    creator: GetEmployeeDto;
    /**
     * 
     * @type {Date}
     * @memberof GetAuthorizedDto
     */
    creationTs: Date;
}

/**
 * Check if a given object implements the GetAuthorizedDto interface.
 */
export function instanceOfGetAuthorizedDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "endDate" in value;
    isInstance = isInstance && "maxAmount" in value;
    isInstance = isInstance && "employee" in value;
    isInstance = isInstance && "company" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "creator" in value;
    isInstance = isInstance && "creationTs" in value;

    return isInstance;
}

export function GetAuthorizedDtoFromJSON(json: any): GetAuthorizedDto {
    return GetAuthorizedDtoFromJSONTyped(json, false);
}

export function GetAuthorizedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAuthorizedDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'endDate': (new Date(json['endDate'])),
        'maxAmount': json['maxAmount'],
        'employee': GetEmployeeDtoFromJSON(json['employee']),
        'company': GetCompanyDtoFromJSON(json['company']),
        'team': !exists(json, 'team') ? undefined : GetTeamDtoFromJSON(json['team']),
        'active': json['active'],
        'creator': GetEmployeeDtoFromJSON(json['creator']),
        'creationTs': (new Date(json['creationTs'])),
    };
}

export function GetAuthorizedDtoToJSON(value?: GetAuthorizedDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'systemNumber': value.systemNumber,
        'endDate': (value.endDate.toISOString()),
        'maxAmount': value.maxAmount,
        'employee': GetEmployeeDtoToJSON(value.employee),
        'company': GetCompanyDtoToJSON(value.company),
        'team': GetTeamDtoToJSON(value.team),
        'active': value.active,
        'creator': GetEmployeeDtoToJSON(value.creator),
        'creationTs': (value.creationTs.toISOString()),
    };
}

